import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { getParamsType } from '../model/getParamsType';
import { SharedService } from './shared.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(private sharedService: SharedService, private router: Router) { }
  canActivate(route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean|Promise<boolean> {
    //let id = route.paramMap.get('id') ?? '';
    let id = route.queryParamMap.get('lid')??'';
    if(!id || this.sharedService.previousStep){
      return true
    }
    else
    return  this.redirectToCurrentStep(id);
  }
  redirectToCurrentStep(id:any){
    let returnVal=true;
    return this.getCurrentStep(id)
    .then(
      (response:any)=>{
        this.router.navigate(response);
        return false;
      },
      (errorResponse)=>{
        this.router.navigate(['contact']);
        return false;
      }
    );
  }
  getCurrentStep(id:any){
    const relativePath: string = 'groupClinic/getClinicLead';
    const getParamsStep2a: getParamsType = {
      entityName: 'lead',
      entityId: id,
      columns:
        'aci_billyourcompanydirectly,aci_collectpaymentfromparticipants,aci_billyourparticipantsinsurers,companyname,emailaddress1,lastname,mobilephone,firstname',
    }
    return new Promise((resolve, reject) => {
      this.sharedService.postRequestPromise(relativePath, getParamsStep2a).then(
      (response: any) => {
        if (response.companyname ) {
          resolve(['/services', { id: id }]);

          // const relativePathgetGroupClinicByLeadId: string = `clinic/getClinicByLeadId`;  
          // const getParamsStep3b: getParamsType = {
          //     entityName: "aci_clinic",
          //     entityId: id,
          //     columns: "aci_clinicid",
          //   }
          //   this.sharedService.postRequestPromise(relativePathgetGroupClinicByLeadId, getParamsStep3b).then(
          //     (clinicListResponse:any)=>{
          //       if (clinicListResponse.value.length >= 1) {
          //         this.sharedService.showWelcomeBanner=1;               
          //          resolve(['/step-3b', { id: id }]);
          //       }
          //       this.sharedService.showWelcomeBanner=1;
          //       resolve(['/step-3a', { id: id }]);
          //     },
          //     (clinicListErrorResponse:any)=>{
          //       resolve(['/step-1']);
          //       console.log(clinicListErrorResponse);
          //     }
          //   );
          
        }
        else{
         if(response.lastname)         
          resolve(['/organisation', { id: id }]);
          else{
            resolve(['/contact']);
          }
        }
      },
      (errorResoposnse:any)=>{
        reject(errorResoposnse);
      }
    );
    });
  }
}
